import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { GENDER_OPTIONS, GENERATION_CATEGORIES } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import FJLocalStore from '../../../../../store/FJLocalStore';
import FJHoverBoardGradation from '../../../../../common/components/FJHoverBoard/FJHoverBoardGradation';
import FJImage from '../../../../../common/components/FJImage/FJImage';
import FJTextWithEllipsisParent from '../../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsisParent';
import classNames from 'classnames';
import FJCheckIcon from '../../../../../assets/svg/check-white.svg?react';
import commonStyles from './StepForm.module.less';
import FJConfig from '../../../../../config/FJConfig';
import FJFileHandleUtil from '../../../../../util/FJFileHandleUtil';

import styles from './FJGenderSelector.module.less';

const FJGenderSelector = ({ selectedGender, onGenderChange, selectedCategory }) => {
    const genderOptionsList = useMemo(() => {
        const isKid = selectedCategory === GENERATION_CATEGORIES.KID;
        return [
            {
                key: GENDER_OPTIONS.MALE,
                title: isKid ? 'boy' : 'male',
                imageUrl: FJFileHandleUtil.getImageUrlWithFormat(
                    `${FJConfig.headshotImagePath}${isKid ? 'boy.png' : 'male.png'}?v=${FJConfig.version}`,
                ),
            },
            {
                key: GENDER_OPTIONS.FEMALE,
                title: isKid ? 'girl' : 'female',
                imageUrl: FJFileHandleUtil.getImageUrlWithFormat(
                    `${FJConfig.headshotImagePath}${isKid ? 'girl.png' : 'female.png'}?v=${FJConfig.version}`,
                ),
            },
        ];
    }, [selectedCategory]);

    return (
        <div className={commonStyles.step_form}>
            <h3 className={commonStyles.step_title}>{FJLocalStore._('whats-your-gender')}</h3>
            <div className={styles.gender_options_grid}>
                {genderOptionsList.map(gender => (
                    <div className={styles.option_card} key={gender.key} onClick={() => onGenderChange(gender.key)}>
                        <FJHoverBoardGradation
                            className={styles.hover_board_box}
                            contentClassName={styles.hover_board_content}
                            active={selectedGender === gender.key}
                            borderRadius={12}
                            isShowInBorder
                            selectBgColor='#ffffff'
                        >
                            <FJImage
                                imgSrc={gender.imageUrl}
                                alt={gender.title}
                                imgClassName={styles.option_image}
                                boxClassName={styles.option_image_box}
                                onRefresh={() => onGenderChange(gender.key)}
                                isShowLoading
                            />
                            <div
                                className={classNames(styles.selected_icon, {
                                    [styles.selected]: selectedGender === gender.key,
                                })}
                            >
                                <FJCheckIcon fill='currentColor' />
                            </div>

                            <div className={styles.option_content}>
                                <FJTextWithEllipsisParent
                                    className={styles.option_title}
                                    text={FJLocalStore._(gender.title)}
                                />
                            </div>
                        </FJHoverBoardGradation>
                    </div>
                ))}
            </div>
        </div>
    );
};

FJGenderSelector.propTypes = {
    selectedGender: PropTypes.string,
    onGenderChange: PropTypes.func,
    selectedCategoryKey: PropTypes.string,
    selectedCategory: PropTypes.string,
};

export default FJGenderSelector;
